module.exports = __webpack_public_path__ + "static/media/white.9446e190.png";